import React from "react";
import { Link } from "react-router-dom";

const PayRoll = () => {
  const menuItems = [
    {
      title: "Dashboard",
      desc: "View key metrics.",
      icon: "bi-grid-3x3-gap",
      link: "/payroll/dashboard",
    },
    {
      title: "Loans",
      desc: "Manage employee loans.",
      icon: "bi-bank",
      link: "/payroll/loans",
    },
    {
      title: "Reimbursements",
      desc: "Process reimbursements.",
      icon: "bi-receipt",
      link: "/payroll/reimbursements",
    },
    {
      title: "Salary Structure",
      desc: "Define compensation grades.",
      icon: "bi-diagram-3",
      link: "/payroll/salary-structure",
    },
    {
      title: "Payroll Run",
      desc: "Execute monthly payroll.",
      icon: "bi-rocket-takeoff",
      link: "/payroll/payroll-run",
    },
    {
      title: "Payroll Items",
      desc: "Manage earnings & deductions.",
      icon: "bi-list-ul",
      link: "/payroll/payroll-items",
    },
    {
      title: "Payroll Formulas",
      desc: "Configure calculations.",
      icon: "bi-calculator",
      link: "/payroll/payroll-formulas",
    },
    {
      title: "Reports",
      desc: "Generate payroll reports.",
      icon: "bi-file-text",
      link: "/payroll/reports",
    },
    {
      title: "Settings",
      desc: "Configure system settings.",
      icon: "bi-gear",
      link: "/payroll/settings",
    },
  ];

  return (
    <div className="container py-5">
      <div className="row g-4 justify-content-center">
        {menuItems.map((item, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
            <Link to={item.link} className="text-decoration-none text-dark">
              <div
                className="p-4 bg-white rounded shadow-sm border"
                style={{ minHeight: "120px" }}
                role="button"
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h5 className="fw-bold">{item.title}</h5>
                    <p className="text-muted mb-0">{item.desc}</p>
                  </div>
                  <i
                    className={`bi ${item.icon} fs-2 text-primary`}
                    style={{ opacity: 0.8 }}
                  ></i>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PayRoll;
